﻿const getCookie = (name) => {
	const cookies = document.cookie.split(";");
	for (let i = 0, l = cookies.length; i < l; i++) {
		const cookie = cookies[i].trimStart();
		const ni = cookie.indexOf("=");
		const cname = ni < 0 ? cookie : cookie.substring(0, ni);
		const cvalue = ni < 0 ? "" : cookie.substring(ni + 1);
		if (cname.toLowerCase() === name)
			return decodeURIComponent(cvalue);
	}
};

const setCookie = (name, value, options = {}) => {
	const { expires, maxAge, path, domain, secure, httpOnly } = { secure: "auto", ...options };
	let flags = "";
	if (expires) {
		if (expires instanceof Date) {
			flags += ";expires=" + expires.toUTCString();
		} else {
			flags += ";expires=" + expires;
		}
	} else if (maxAge) {
		flags += ";max-age=" + maxAge;
	}
	if (path) flags += ";path=" + path;
	if (domain) flags += ";domain=" + domain;
	if (secure) flags += secure !== "auto" || location.protocol.toLowerCase() === "https:" ? ";secure" : "";
	if (httpOnly) flags += ";httpOnly";

	const result = `${name}=${encodeURIComponent(value)}${flags}`;
	console.log("setCookie", result);
	document.cookie = result;
};

const cookieExpired = new Date(0);

const removeCookie = (name, options = {}) => {
	setCookie(name, "", { ...options, expires: cookieExpired });
};

export { getCookie, setCookie, removeCookie };